import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateSpaceAPI } from "api/spaceApi";
import { DeleteSpaceAPI } from "api/spaceApi";
import { GetSpaceAPI } from "api/spaceApi";
import { CreateSpaceAPI } from "api/spaceApi";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  spaces: [],
  loading: false,
  placeId: "",
};

export const createSpace = createAsyncThunk(
  "space/createSpace",
  async (data, { rejectWithValue }) => {
    console.log(data, "<==data");
    try {
      const response = await CreateSpaceAPI(data);
      return response.data;
    } catch (err) {
      console.log("postSpace err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getSpaces = createAsyncThunk(
  "space/getSpaces",
  async (placeId, { rejectWithValue }) => {
    try {
      const response = await GetSpaceAPI(placeId);
      return response.data;
    } catch (err) {
      console.log("get space err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const deleteSpace = createAsyncThunk(
  "space/deleteSpace",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DeleteSpaceAPI(data);
      return response.data;
    } catch (err) {
      console.log("Delete err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const updateSpace = createAsyncThunk(
  "space/updateSpace",
  async (updateSpaceData, { rejectWithValue }) => {
    console.log(updateSpaceData, "<<update space data");
    try {
      const response = await updateSpaceAPI(updateSpaceData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const spaceSlice = createSlice({
  name: "spaces",
  initialState,
  reducers: {
    setSpace: (state, action) => {
      state.slacks = action.payload;
    },
    setPlaceIdForSpace: (state, action) => {
      state.placeId = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getSpaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSpaces.fulfilled, (state, { payload }) => {
        state.spaces = payload.spaces;
        state.loading = false;
      })
      .addCase(getSpaces.rejected, (state) => {
        state.loading = false;
      }),
});

export const { setSpace, setPlaceIdForSpace } = spaceSlice.actions;
export default spaceSlice.reducer;
